import React, { Component } from "react";
import { Row, Card, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { connect } from "react-redux";
import { loginUser, logoutUser, setLoader, setTenants, setCurrentTenant, setMenuItems, changeLocale, } from "../../redux/actions";
import { Colxx } from "../../components/common/CustomBootstrap";
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import { logo, authType, authParams, tenants } from "../../config/defaultValues";
import {getValueOfParameterFromURL} from "../../helpers/Utils";
import AppLocale from "../../config/lang";
import classnames from 'classnames';
import FormCustom from "../../components/utils/FormCustom";
import countryCodes from '../../data/countryCodes'

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      password: null,
      prelog: null,
      activeTab: window.tenant.appName !== 'AppOnCloud' ? "1" : "2",
      form1: null,
      form2: null,
      form1Fields: [],
      form2Fields: [],
      pinSent: false,
      readyForm1: false,
      readyForm2: false
    };

    if (authType === 2) {
      //check for token from redirection
      if (localStorage.getItem("token")) {
        this.redirectFlowUserDetails(localStorage.getItem("token"));
        //localStorage.removeItem("token");
      }
    }
  }

  UNSAFE_componentWillMount() {
    this.getParamsFromURL()
    .then(() => {
      this.createForm()
    })
    .catch((error) => {
      console.error(error.message);
    }) 
  }

  componentDidMount() {
    let form1 = this.state.form1
    let code = parseInt(localStorage.getItem('countryCode'))
    let mobile = localStorage.getItem('mobileNumber') || ''
    form1 = {...form1, ...{countryCode: code?? '', mobile: mobile}}
    this.setState({form1: form1})
  }

  getParamsFromURL = () => {
    return new Promise((resolve, reject) => {
      try {
        let token = getValueOfParameterFromURL("token")
        if (token) {
          this.loginToken(token)
          resolve()
        } else resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  createForm = () => {
    const L = AppLocale[this.props.locale].messages

    const fields1 = [
      {
        col: 4,
        colxs: 4,
        name: "countryCode",
        value: this.state.form1?.countryCode,
        type: "select",
        label: "",
        rules: "required",
        placeholder: "main.plusCountryCode",
        opts: {
          items: countryCodes,
          isClearable: false,
          colClassName: "pr-0",
          filterOption: (option, searchText) => {
            let label = option.data.label.split(" ")
            if (label[1].toLowerCase().startsWith(searchText.toLowerCase()) || label[0].toLowerCase().includes(searchText.toLowerCase())) {
              return true;
            } else {
              return false;
            }
          }
        },
        onChange: (ctx) => {
          if (ctx.state.countryCode) localStorage.setItem('countryCode', ctx.state.countryCode)
        }
      },
      {
        col: 8,
        colxs: 8,
        id: "mobile",
        name: "mobile",
        value: this.state.form1?.mobile || "",
        type: "number",
        label: "",
        placeholder: "main.mobileNumber",
        rules: "required|max:9",
        clearable: true,  // Make sure this is set to true
        autoComplete: true,
        onKeyPress: e => e.key === 'Enter' ? this.verifyNumber() : null,
        onChange: (ctx) => {
          if (ctx.state.mobile) localStorage.setItem('mobileNumber', ctx.state.mobile)
        },
        opts: {
          colClassName: "pl-0",
          addon: {
            append: {
              buttons: [
                {
                  icon: "icomoon-message",
                  className: "btn-send-phoneNumber",
                  outline: () => this.state.pinSent,
                  onClick: () => { this.verifyNumber() }
                }
              ]
            }
          }
        }
      },
      {
        col: 12,
        name: "code",
        value: "",
        type: "number",
        rules: "required",
        onKeyPress: e => e.key === 'Enter' ? this.loginCellphone() : null,
        opts: {
          addon: {
            prepend: {
              texts: ["main.otp"]
            }
          }
        },
        renderIf: () => this.state.pinSent
      },
      {
        col: 6,
        colxs: 5,
        value: `<a href="/" class="btn-link mt-5" style="height: 44px; display: flex; align-items: center;">${L["main.mod_app"]}</a>`,
        name: "label2",
        type: "label",
        renderIf: () => window.tenant.appName === 'AppOnCloud'
      },
      {
        col: window.tenant.appName !== 'AppOnCloud' ? 12 : 6,
        colxs: window.tenant.appName !== 'AppOnCloud' ? 12 : 7,
        name: "btnLogin2",
        type: "button",
        label: "main.login",
        className: "px-5",
        onClick: () => { this.loginCellphone() },
        opts: {
          wrapperClassName: "d-flex justify-content-end"
        },
        renderIf: () => this.state.pinSent
      }
    ]
    this.setState({form1Fields: fields1}, () => {
      this.setState({readyForm1: true})
    })

    const fields2 = [
      {
        col: 12,
        name: "email",
        value: "",
        type: "text",
        label: "main.mail",
        rules: "required|email",
        autoComplete: true,
        opts: {
          style: 'float-label',
        }
      },
      {
        col: 12,
        name: "pass",
        value: "",
        type: "password",
        label: "main.password",
        rules: "required",
        autoComplete: true,
        onKeyPress: e => e.key === 'Enter' ? this.validateForm() : null,
        opts: {
          style: 'float-label',
        }
      },
      {
        col: 6,
        colxs: 5,
        value: `<a href="/" class="btn-link" style="height: 44px; display: flex; align-items: center;">${L["main.mod_app"]}</a>`,
        name: "label1",
        type: "label",
        renderIf: () => window.tenant.appName === 'AppOnCloud'
      },
      {
        col: window.tenant.appName !== 'AppOnCloud' ? 12 : 6,
        colxs: window.tenant.appName !== 'AppOnCloud' ? 12 : 7,
        name: "btnLogin1",
        type: "button",
        label: "main.login",
        className: "px-5",
        onClick: () => { this.validateForm() },
        opts: {
          wrapperClassName: "d-flex justify-content-end"
        }
      }
    ]
    this.setState({form2Fields: fields2}, () => {
      this.setState({readyForm2: true})
    })
  }

  validateForm = () => {
    this.validateForm2().then(() => {
      this.props.setLoader(true);
      authType === 3 ? this.loginResourceOwner() : authType === 2 ? this.loginRedirect() : this.login()
    })
    .catch(e => { /* console.log(e) */ })
  }

  listenStatesForm1 = (s) => {
    this.setState({ form1: s });
  }

  listenStatesForm2 = (s) => {
    this.setState({ form2: s });
  }

  verifyNumber = () => {
    this.validateForForm1(null, ['countryCode', 'mobile']).then(() => {
      this.props.setLoader(true)
      _axios
        .post('user/mauthpin', {user: `${this.state.form1.countryCode}${this.state.form1.mobile}`, admin: true})
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) this.setState({pinSent: true}, () => {
            setTimeout(() => { document.getElementById("form-login-cellphone-code").focus()}, 500)
          })
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(validationFailed => {
      // console.log(validationFailed)
    })
  }

  loginCellphone = () => {
    this.validateForm1().then(() => {
      this.props.setLoader(true)
      _axios
        .post('user/login', {user: `${this.state.form1.countryCode}${this.state.form1.mobile}`, pass: this.state.form1.code, admin: true})
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.loginToken(r.data.token)
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  loginToken(token) {
    this.props.setLoader(true)
    _axios
      .get("admStaff/loginToken", {headers: {'Content-Type': 'application/json;charset=UTF-8', 'token': token}})
      .then(r => {
        this.loginSuccess(r)
      })
      .catch(() => {
        this.props.setLoader(false)
      })
  }

  login() {
    this.props.setLoader(true)
    _axios
      .post("admStaff/login?adm=true", { ext: '', user: this.state.form2.email, pass: this.state.form2.pass })
      .then(r => {
        this.loginSuccess(r)
      })
      .catch(() => {
        this.props.setLoader(false)
      })
  }

  loginSuccess(r) {
    if (authParams.map) r = authParams.map(r);
    if (r.status >= 0) {
      if (['sansilvestre', 'santamaria'].indexOf(window.tenant.id) === -1) document.title = `${window.tenant.appName} - ${r.data.companyName}`
      // Set theme color from login response if available
      if (r.data.color && !r.data.color.startsWith('#')) { 
        localStorage.setItem('__theme_color', r.data.color);
      }
      this.loggedIn(r.data);
      if(r.data.defaultLang) this.props.changeLocale(r.data.defaultLang.toLowerCase());
    } else NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
    this.props.setLoader(false)
  }

  loginRedirect(force) {
    document.location.href = authParams.Path + '/auth/core/connect/authorize?client_id='
      + authParams.ClientId
      + (force ?'&prompt=login' :'')
      + '&redirect_uri=' + encodeURIComponent(document.location.origin + '/authorized.html')
      + '&response_type=id_token%20token&scope=openid%20profile%20email%20roles%20all_claims%20getbee&nonce=' + Math.random().toString(36).substr(2);
  }

  continueLogin() {
    this.loggedIn(this.state.prelog);
  }

  loginResourceOwner() {
    let config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "*/*",
        "Authorization": 'Basic ' + authParams.Basic
      }
    };

    _axios
      .post(authParams.Path + '/auth/core/connect/token', 'grant_type=password&username=' + this.state.email + '&password=' + this.state.password + '&scope=offline_access', config)
      .then(r => {
        if (!r.error) {
          if (!authParams.GetUser || authParams.GetUser.length === '') {
            NotificationManager.error('authGetUser url not set', "!", 5000, null, null, 'outline');
            return;
          }
          _axios.post(authParams.Path + '/auth/core/connect/token', 'grant_type=refresh_token&refresh_token=' + r.refresh_token, config)
            .then(rt => {

              //make user details call
              this.redirectFlowUserDetails(rt.access_token);
            });

        } else NotificationManager.error(r.error, "!", 5000, null, null, 'outline')
      })
  }

  redirectFlowUserDetails(token) {
    this.props.setLoader(true);

    let config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + token
      }
    };

    _axios.get(authParams.GetUser, config).then(rr => {
      if (authParams.map) rr = authParams.map(rr);
      rr.data.token = token;
      if(authType === 2)
      {
        this.setState({ prelog: rr.data });
        this.props.setLoader(false); // allow manual continue
      }
      else this.loggedIn(rr);
    },
      err => {
        if(authType === 2) this.loginRedirect(true);
        else {
          this.props.setLoader(false);
          NotificationManager.error('Could not login. Maybe you do not have permissions? :(', "!", 5000, null, null, 'outline');
        }
      }
    );
  }

  loggedIn(r) {
    r.menu.map((e) => {
      e.to = "/app/" + e.id
      e.subs = e.subs.map((ee) => {
        ee.label = ee.name
        ee.labelEn = ee.name
        ee.to = "/app/" + ee.id
        ee.configFields = ee.config
        delete ee.name
        delete ee.img
        delete ee.led
        delete ee.order
        delete ee.fields
        return ee
      })
      
      delete e.desc
      delete e.fields
      delete e.img
      delete e.led
      delete e.order
      return e
    })

    let temp = [
      {
        "id": "home",
        "icon": "iconsminds-up-1",
        "hidden": false,
        "config": null,
        "name": "Inicio",
        "nameEn": "All",
        "to": "/app/home/start"
      }
    ]

    r.menu = r.menu.concat(temp)

    this.props.setMenuItems(r.menu);
    this.props.loginUser(r, this.props.history);

    this.getTenants(r.multiTenant ? false : r);
  }

  async getTenants(singleTenant) {
    var t;
    
    if (singleTenant!==false) {
      t = [
        { id: singleTenant.companyID, name: singleTenant.companyName, url: '', img: singleTenant.companyPic },
      ];
    }
    else {
      this.props.setLoader(true);
      await _axios
        .get(tenants.pathAll)
        .then(r => {
          if (tenants.map) r = tenants.map(r);
          t = r.data;
          t.unshift({ id: 0, name: '[Select tenant]' });
        },
          err => {
            t = tenants.default;
          });
    }

    this.props.setTenants(t);
    this.props.setCurrentTenant(t[0]);
  }

  componentWillUnmount() {
    this.props.setLoader(false);
  }

  clearPhoneData = () => {
    localStorage.removeItem('countryCode')
    localStorage.removeItem('mobileNumber')
    this.setState({
      form1: {
        ...this.state.form1,
        countryCode: '',
        mobile: ''
      }
    })
  }

  render() {
    const L = AppLocale[this.props.locale].messages
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">

          <Card className="auth-card">
            <div className="position-relative image-side d-flex justify-content-center align-items-center" style={{backgroundColor: `var(--theme-color-1)`}}>
              <img src={logo} alt="" className="w-50 rounded-circle"/>
            </div>
            <div className="form-side">
              <h3 className="mb-4">{L["main.login"]}</h3>

              <Nav tabs className="separator-tabs ml-0 mb-5">
                {window.tenant.appName !== 'AppOnCloud' && <NavItem>
                  <NavLink
                    location={{}}
                    to="#"
                    className={classnames({
                      active: this.state.activeTab === '1',
                      'nav-link': true,
                    })}
                    onClick={() => this.setState({activeTab: "1"}) }
                  >
                    {L["main.cellPhone"]}
                  </NavLink>
                </NavItem>}
                <NavItem>
                  <NavLink
                    location={{}}
                    to="#"
                    className={classnames({
                      active: this.state.activeTab === '2',
                      'nav-link': true,
                    })}
                    onClick={() => this.setState({activeTab: "2"}) }
                  >
                    {L["main.email"]}
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={this.state.activeTab}>
                {window.tenant.appName !== 'AppOnCloud' && <TabPane tabId="1">
                  {this.state.readyForm1 && <FormCustom
                    id={"form-login-cellphone"}
                    fields={this.state.form1Fields}
                    listenStates={this.listenStatesForm1}
                    validate={fn => this.validateForm1 = fn}
                    validateFor={fn => this.validateForForm1 = fn}
                    didUpdateStates={true}
                  />}
                </TabPane>}

                <TabPane tabId="2">
                  {this.state.readyForm2 && <FormCustom
                    id={"form-login-email"}
                    fields={this.state.form2Fields}
                    listenStates={this.listenStatesForm2}
                    validate={fn => this.validateForm2 = fn}
                    didUpdateStates={true}
                  />}
                </TabPane>
              </TabContent>
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

const mapStateToProps = ({ authUser, settings }) => {
  const { user } = authUser;
  const { locale } = settings
  return { user, locale };
};

export default connect(mapStateToProps, { loginUser, logoutUser, setLoader, setTenants, setCurrentTenant, setMenuItems, changeLocale })(Login);